<template>
  <v-parallax
    dark
    src="/img/HealthView_HomeHealth_bg1.jpg"
    class="para"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-card
        flat
        class="mx-auto"
        color="transparent"
        max-width="800"
      >
        <v-card-text>
          <h2 class="primary--text text-center text-md-h1 text-h2">
            Growing Your Business With HealthView Capital Partners
          </h2>
        </v-card-text>
      </v-card>
      <!-- <img src="/img/HealthViewCapital-ColorLogo.png"> -->
    </v-row>
  </v-parallax>
</template>

<script>
export default {
  name: 'Banner',
  data: () => ({
    msg: 'Message',
  }),
  methods: {},
}
</script>
